module.exports = __webpack_public_path__ + "img/4.3a0ebcf7.jpg";